<script setup>
import { computed, getCurrentInstance, watch } from 'vue';
import { useAsyncState } from '@vueuse/core';

const props = defineProps({
    contentId: Number,
    item: Object
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// 1. Fetch Content
const { state: content, execute: fetchContent } = useAsyncState(
    () => store.dispatch('itemData/get', { tableName: 'content', id: props.contentId }),
    null
);

// 2. Fetch ContentType
const { state: contentType, execute: fetchContentType } = useAsyncState(
    async () => {
        if (!content.value) return null;
        return store.dispatch('itemData/get', {
            tableName: 'templates_templates',
            id: content.value.contentType
        });
    },
    null,
    { immediate: false }
);

// Watch for contentId changes to restart the chain
watch(() => props.contentId, () => fetchContent(), { immediate: true });

// Watch content to trigger the next link in the chain
watch(content, (newVal) => {
    if (newVal) fetchContentType();
});

const componentId = computed(() => contentType.value?.componentId);

const component = computed(() => {
    return store.state.components.items.find(o => o.id === componentId.value);
});

const fields = computed(() => {
    if (!componentId.value) return [];
    const structure = store.getters['componentStructure/get'](componentId.value);
    if (!structure) return [];

    return structure
        .slice()
        .sort((a, b) => (a.title > b.title ? 1 : -1))
        .filter((o) => {
            const options = store.getters['collectionFilters/typesOptions'](o.type, props.item.fieldId);
            return options.length > 0;
        });
});
</script>

<template>
    <select v-model.number="item.fieldId" class="form-select form-select-sm d-inline-block w-auto">
        <option :value="null">{{ component?.title }} items</option>
        <option disabled>──────────</option>
        <option v-for="field in fields" :key="field.id" :value="field.id">
            {{ field.title }}
        </option>
    </select>
</template>